import styled from 'styled-components';

export const Title = styled.h1`
  color: ${({ theme }) => theme.colors.blackColor};
  font-size: 64px;
  text-align: center;
  line-height: 80px;
  letter-spacing: 0.25px;

  @media (max-width: 1035px) {
    font-size: 40px;
    line-height: 44px;
  }
`;
